import React from "react";
import { Dropdown } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import withRoleCheck from "components/hocs/withRoleCheck";
import CustomDropdown from "components/CustomDropdown";
import _DeleteContractModal from "routes/entity/components/DeleteContractModal";
import _ContractModal from "routes/entity/components/ContractModal";

const EditContractModal = withRoleCheck(_ContractModal, [
  ACL_RELATIONSHIPS.contract.edit,
  ACL_RELATIONSHIPS.contractForFilters.read,
]);

const DeleteContractModal = withRoleCheck(_DeleteContractModal, [
  ACL_RELATIONSHIPS.contract.delete,
]);

export function ContractsTableActions({
  original,
  entityId,
  deleteContract,
  invalidateData,
}) {
  return (
    <CustomDropdown icon="ellipsis horizontal">
      <Dropdown.Menu direction="left">
        <EditContractModal
          contract={original}
          entityId={entityId}
          onSuccess={invalidateData}
        />
        <DeleteContractModal
          onConfirmDelete={() => deleteContract(original.id, entityId)}
          menuTrigger
        />
      </Dropdown.Menu>
    </CustomDropdown>
  );
}
